import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SemanticToastContainer } from 'react-semantic-toasts';
import ActionBar from 'pages/Kyb/ActionBar';
import {
  loadKybBusinessDetail,
  loadKybBusinessesList,
} from 'state/kyb/actions';
import BusinessesList from 'pages/Kyb/BusinessesList';
import autoBind from 'auto-bind';
import BusinessDetailModal from 'pages/Kyb/BusinessDetailModal';
import { loadGlobalBankList } from 'state/global/actions';

export class KybReviewPage extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    const {
      dispatch,
      businesses: { filters },
    } = this.props;
    dispatch(loadGlobalBankList());
    this.onFilterChanged(filters);
  }

  onFilterChanged(filters) {
    const {
      dispatch,
      businesses: {
        data: { size },
      },
    } = this.props;
    dispatch(loadKybBusinessesList(filters, { page: 1, size }));
  }

  onBusinessesListPageChange(page) {
    const {
      dispatch,
      businesses: {
        filters,
        data: { size },
      },
    } = this.props;
    dispatch(loadKybBusinessesList(filters, { page, size }));
  }

  // TODO: remove rule below
  // eslint-disable-next-line class-methods-use-this
  onBusinessItemClicked(businessId) {
    const { dispatch } = this.props;
    dispatch(loadKybBusinessDetail(businessId));
  }

  render() {
    const {
      businesses: { data, filters, isLoading },
    } = this.props;

    return (
      <>
        <SemanticToastContainer />
        <h1>KYB Review</h1>
        <br />
        <ActionBar filters={filters} onApplyFilter={this.onFilterChanged} />
        <BusinessesList
          isLoading={isLoading}
          data={data}
          onBusinessItemClicked={this.onBusinessItemClicked}
          onPageChange={this.onBusinessesListPageChange}
        />
        <BusinessDetailModal />
      </>
    );
  }
}

const mapStateToProps = state => ({
  ...state.kyb,
});

KybReviewPage.propTypes = {
  businesses: PropTypes.shape({
    data: PropTypes.shape({
      list: PropTypes.array.isRequired,
      page: PropTypes.number.isRequired,
      size: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
    }),
    filters: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(KybReviewPage);
